import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { updateElement } from '../api/reports.api';
import {
  REPORT_DETAIL_QUERY_KEY,
  REPORT_ELEMENT_DATA_PAGINATED_QUERY_KEY,
  REPORT_ELEMENT_DATA_QUERY_KEY,
} from '../constants/reports-query-keys';

export const useUpdateElement = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: ({
      reportId,
      elementId,
      body,
    }: {
      reportId: string;
      elementId: string;
      body: Partial<{
        type: string;
        position: { x: number; y: number; width: number; height: number };
        config: Record<string, unknown>;
        reportType: string;
        columns: string[];
        groupBy: string[];
        pivotDimension: string | null;
        customMeasures: unknown[];
        localFilters: unknown[];
      }>;
    }) => updateElement(reportId, elementId, body),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: REPORT_DETAIL_QUERY_KEY(data.id) });
      queryClient.invalidateQueries({
        queryKey: [...REPORT_ELEMENT_DATA_QUERY_KEY, variables.reportId, variables.elementId],
      });
      queryClient.invalidateQueries({
        queryKey: [
          ...REPORT_ELEMENT_DATA_PAGINATED_QUERY_KEY,
          variables.reportId,
          variables.elementId,
        ],
      });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.reports:toasts.elementUpdateError'
      );
    },
  });
};
